import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./context/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import "./i18n"; // Import the i18n configuration
import { CustomToast } from "./utils/Toast";
import { SavedCarsProvider } from "./context/SavedCarIdsContext";
import { SavedLocalCarsProvider } from "./context/SavedLocalCarsIdscontext";
import { FundsProvider } from "./context/FundsContext";
import "./instrument"
import * as Sentry from "@sentry/react";
import { WireTransferProvider } from "./context/WireTransferContext";
import Clarity from '@microsoft/clarity';

Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID || "rvh0m1bc1g");


// Add this polyfill before Sentry initialization
if (!Promise.withResolvers) {
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const ErrorFallback = () => (
  <div className="error-container">
    <h2>Oops! Something went wrong.</h2>
    <p>Please refresh the page or try again later.</p>
    <button onClick={() => window.location.reload()}>Refresh</button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <AuthContextProvider>
      <FundsProvider>
        <WireTransferProvider>
        <SavedCarsProvider>
          <SavedLocalCarsProvider>
            <CustomToast />
            <App />
          </SavedLocalCarsProvider>
        </SavedCarsProvider>
        </WireTransferProvider>
      </FundsProvider>
      </AuthContextProvider>

   </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals)
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
